import { adminHttpClient } from '../../../commons/adminHttpClient'
import { PaymentStatus } from 'domain/benefit/paymentStatus'

export interface Invoice {
  date: string
  invoiceNumber: number
  amount: number
  status: PaymentStatus
  viewUrl: string
}

const getInvoices = (year: number): Promise<any> => {
  return adminHttpClient.get('/AdminDashboard/CompanySettings/CompanySubscription/Invoices/' + year)
}

export default getInvoices
